<template>
  <div id="info-add-dialog">
    <ipub-model :title="`${inputData.id?'Edit':'Add a New'} Info Page`"
                width="800px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="info-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Title">
          <ipub-input placeholder="Enter info page title here"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="code"
                        label="Tail Path">
          <ipub-input placeholder="Enter tail path"
                      v-model.trim="params.code" />
        </ipub-form-item>
        <ipub-form-item prop="content"
                        label="Content">
          <ipub-editor :height="200"
                       placeholder="Enter content detail here"
                       v-model.trim="params.content" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import info from '@/api/info'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (val) {
        if (this.inputData.id) {
          this.getQuery()
        }
      } else {
        this.params = {}
      }
    }
  },
  data () {
    return {
      rules: {},
      params: {}
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async getQuery () {
      this.params = await info.query(this.inputData.id)
    },
    async confirm () {
      const flag = this.$refs['info-add-form'].validate()
      if (!flag) {
        return
      }
      if (this.params.id) {
        await info.edit(this.params.id, this.params)
      } else {
        await info.add(this.params)
      }
      this.$message.success({ title: 'Success', content: `This Info Page has been saved!` })
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 200,
            message: this.LANGUAGE[this.language].textToLong
          }
        ],
        code: [
          {
            required: true,
            message:
              'Tail Path' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 200,
            message: this.LANGUAGE[this.language].textToLong
          },
          {
            type: 'numberAndLetter',
            message: 'Must consist of numbers and letters'
          },
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
